module.exports = __webpack_public_path__ + "static/works-gawean-fbad8730b8d959f085f199c381148be9.png";